export default __webpack_public_path__ + "static/media/404.75afdf63.png";